module.exports = __webpack_public_path__ + "static/img/b01.145eff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b01.jpg
// module id = IF2i
// module chunks = 1